import React from 'react';

export function DZentLogo({ size = 48, variant = 'full', className = '' }) {
  const s = size;
  const iconSize = s;
  const fontSize = s * 0.4;

  if (variant === 'icon') {
    return (
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        data-testid="dzent-logo-icon"
      >
        {/* Background rounded square */}
        <rect width="120" height="120" rx="28" fill="#0A192F" />

        {/* Abstract D + Z mark */}
        {/* D shape - left arc */}
        <path
          d="M32 30 L32 90 Q32 95 37 95 L50 95"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M50 95 Q82 95 82 62.5 Q82 30 50 30 L37 30 Q32 30 32 30"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />

        {/* Z lightning bolt - cutting through */}
        <path
          d="M52 42 L78 42 L55 62 L82 62 L48 82 L58 65 L38 65 Z"
          fill="white"
          opacity="0.95"
        />

        {/* Accent dot */}
        <circle cx="93" cy="88" r="5" fill="#6366F1" />
      </svg>
    );
  }

  // Full logo with text
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="dzent-logo-full">
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="120" height="120" rx="28" fill="#0A192F" />
        <path
          d="M32 30 L32 90 Q32 95 37 95 L50 95"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M50 95 Q82 95 82 62.5 Q82 30 50 30 L37 30 Q32 30 32 30"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M52 42 L78 42 L55 62 L82 62 L48 82 L58 65 L38 65 Z"
          fill="white"
          opacity="0.95"
        />
        <circle cx="93" cy="88" r="5" fill="#6366F1" />
      </svg>
      <div style={{ lineHeight: 1.1 }}>
        <div
          style={{
            fontSize: `${fontSize}px`,
            fontWeight: 800,
            color: '#0A192F',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            letterSpacing: '-0.03em',
          }}
        >
          DZent
        </div>
        <div
          style={{
            fontSize: `${fontSize * 0.45}px`,
            fontWeight: 500,
            color: '#6b7280',
            fontFamily: "'Manrope', sans-serif",
            letterSpacing: '0.08em',
          }}
        >
          LIMITED
        </div>
      </div>
    </div>
  );
}

export function DZentLogoWhite({ size = 48, variant = 'full', className = '' }) {
  const s = size;
  const iconSize = s;
  const fontSize = s * 0.4;

  if (variant === 'icon') {
    return (
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        data-testid="dzent-logo-icon-white"
      >
        <rect width="120" height="120" rx="28" fill="white" />
        <path
          d="M32 30 L32 90 Q32 95 37 95 L50 95"
          stroke="#0A192F"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M50 95 Q82 95 82 62.5 Q82 30 50 30 L37 30 Q32 30 32 30"
          stroke="#0A192F"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M52 42 L78 42 L55 62 L82 62 L48 82 L58 65 L38 65 Z"
          fill="#6366F1"
          opacity="0.95"
        />
        <circle cx="93" cy="88" r="5" fill="#0A192F" />
      </svg>
    );
  }

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="dzent-logo-full-white">
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="120" height="120" rx="28" fill="white" fillOpacity="0.1" stroke="white" strokeOpacity="0.2" strokeWidth="1" />
        <path
          d="M32 30 L32 90 Q32 95 37 95 L50 95"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M50 95 Q82 95 82 62.5 Q82 30 50 30 L37 30 Q32 30 32 30"
          stroke="#6366F1"
          strokeWidth="7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M52 42 L78 42 L55 62 L82 62 L48 82 L58 65 L38 65 Z"
          fill="white"
          opacity="0.95"
        />
        <circle cx="93" cy="88" r="5" fill="#6366F1" />
      </svg>
      <div style={{ lineHeight: 1.1 }}>
        <div
          style={{
            fontSize: `${fontSize}px`,
            fontWeight: 800,
            color: 'white',
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            letterSpacing: '-0.03em',
          }}
        >
          DZent
        </div>
        <div
          style={{
            fontSize: `${fontSize * 0.45}px`,
            fontWeight: 500,
            color: 'rgba(255,255,255,0.5)',
            fontFamily: "'Manrope', sans-serif",
            letterSpacing: '0.08em',
          }}
        >
          LIMITED
        </div>
      </div>
    </div>
  );
}
